import OptionsPanelField from './OptionsPanelField';

const MultiSelectField = (props) => <OptionsPanelField {...props} multiSelect />;

export default MultiSelectField;
